import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {JobInterface} from '../../../../shared/models/job.model';
import {NgForm} from '@angular/forms';
import {UserDataService} from '../../../../modules/auth/user-data.service';
import {JobsDataService} from '../../../../modules/jobs/jobs-data.service';
import {UploadService} from '../../../../shared/upload.service';

@Component({
    selector: 'app-apply-job',
    templateUrl: './apply-job.component.html',
    styleUrls: ['./apply-job.component.scss']
})
export class ApplyJobComponent implements OnInit {

    formResponse: boolean;
    formSent: boolean;
    customSuccessMessage: string;

    jobId: any;
    job: JobInterface;
    jobLoaded = false;
    user: any;
    userAlreadyApplied = false;
    isLoading = false;
    selectedCv: any;
    selectedLetter: any;
    constructor(private route: ActivatedRoute,
                private router: Router,
                private jobDataService: JobsDataService,
                private userData: UserDataService,
                private uploadService: UploadService) {
    }

    ngOnInit(): void {
        
        // Get user from guard
        this.userData.getData().subscribe((user:any) => {
            this.user = user;
            console.log('user',user); 
            this.userData.getUserById(user.id).subscribe((candidate:any)=>{
            console.log('candidate',candidate);
        })
        }, error => {
            this.router.navigate(['/autentificare'])
        });

       

        // Get job id from url
        this.route.params.subscribe((params: Params) => {
            this.jobId = params.id;
            // Load current job
            this.jobDataService.getCurrentJob(this.jobId).subscribe(jobRes => {
                // If id don't exist redirect user to 404
                if (jobRes === null) {
                    this.router.navigate(['/404']);
                }
                // Job fetching finish, load the job
                this.job = jobRes;
                console.log('job',this.job);
                this.jobLoaded = true;
                // Check application status
                this.jobDataService.applicationStatus(this.jobId).subscribe(res => {
                    // If user already applied redirect to my applications
                    if (res['success']) {
                        this.userAlreadyApplied = true;
                        this.redirectUser();
                    }
                }, error => {
                })
            }, error => {
            });
        })
    }

    onSubmit(interviewForm: NgForm) {
        // Show loader after submiting form
        this.isLoading = true;
       
        // Create application Object
        const application = {
            jobId: this.jobId,
            // @ts-ignore
            userId: this.user.id,
            applicationMessage: '',
            applicationMessages: [],
            applicationObservations: '',
            candidateApplicationMessage: interviewForm.value.applicationMessage,
            miniInterviewAnswers: {
                question1: this.job.miniInterview.question1,
                answer1: interviewForm.value.answer1,
                question2: this.job.miniInterview.question2,
                answer2: interviewForm.value.answer2,
                question3: this.job.miniInterview.question3,
                answer3: interviewForm.value.answer3,
                question4: this.job.miniInterview.question4,
                answer4: interviewForm.value.answer4,
                question5: this.job.miniInterview.question5,
                answer5: interviewForm.value.answer5
            },
            candidateLinguisticCompetences: this.user.foreignLanguage,
            applicationDetail: {
                jobName: this.job.jobTitle,
                jobSalary: this.job.salary,
                jobLocation: this.job ,
                workTypeJob:this.job.workType,
                postingDate: this.job.jobPostingDate,
                status: this.job.status,
                logo: this.job.photo,
                city: this.job.city,
                country: this.job.country
            },
            statusApplication: {
                responseStatus: 'noAnswerReceived',
                interviewDate: null,
                hasInterviewDate: null,
                jobClosed: null,
                statusMessage: null
            },
            intentLetter: 'string',
        };

        if (interviewForm.valid) {
            // Send apply request
            this.jobDataService.applyToJob(application, this.user['email']).subscribe(res => {
                if (res['success']) {
                    this.formResponse = true;
                    this.formSent = true;
                    this.customSuccessMessage = "Felicitari, candidatura ta a fost expediata companiei angajatoare! Urmareste, in contul tau, statusul aplicatiei! In curand vei fi redirectionat catre pagina 'Aplicatiile mele!'";

                    this.uploadService.upload(this.selectedLetter, '/uploadRecommendationLetter?applicationId=' + res['reason']);
                    this.isLoading = false;
                    this.userAlreadyApplied = true;
                    interviewForm.resetForm();
                    this.redirectUser();
                } else {
                    this.formResponse = false;
                    this.formSent = true;
                }

            }, error => {
            })
        } else {
            this.formResponse = false;
            this.formSent = true;
            this.isLoading = false;
        }


    }

    // Redirect user after a few seconds
    redirectUser() {
        setTimeout(() => {
            this.router.navigate(['/aplicatiile-mele']);
        }, 10000);
    }

    selectCv(e) {
        this.selectedCv = e.target.files;
    }

    selectLetter(e) {
        this.selectedLetter = e.target.files;
    }

}
